// extracted by mini-css-extract-plugin
module.exports = {"container":"SetMembershipPrice_PriceSelect_container__3Hatj","label":"SetMembershipPrice_PriceSelect_label__1Dela"};